import React from 'react';
import { Document } from '@react-pdf/renderer';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import Page4 from './Page4';
import Page5 from './Page5';

const MyDocument = ({ formData, chartImage, companyLogo }) => (
  
  <Document>
    <Page1 formData={formData} companyLogo={companyLogo} />
    <Page2 formData={formData} companyLogo={companyLogo} />
    <Page3 formData={formData} companyLogo={companyLogo} />
    <Page4 formData={formData} chartImage={chartImage} companyLogo={companyLogo} />
    <Page5 formData={formData} companyLogo={companyLogo} />
  </Document>
);

export default MyDocument;